import { Component } from '@angular/core';

@Component({
  selector: 'app-general-modal-layout',
  imports: [],
  templateUrl: './general-modal-layout.component.html',
})
export class GeneralModalLayoutComponent {}
